import { useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { find } from 'lodash'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'
import { areSameValue } from '../../core/utils'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { MENU_CURATION_TASK_REFRESH_COUNTS_QUERY } from '../../menu-curation-tasks/graphql/queries'
import { REFRESH_MENU_CURATION_TASK_COUNTS } from '../../menu-curation-tasks/redux/action-types'
import { CONFIRM_UNKNOWN_WORD_MUTATION } from '../graphql/mutations'
import { CONFIRM_UNKNOWN_WORD } from '../redux/action-types'

const useConfirmUnknownWordMutation = unknownWordId => {
  const sessionId = useRef(nanoid())
  const { id: menuCurationTaskId } = useParams()
  const dispatch = useDispatch()

  const { isLoading, error } =
    useSelector(store =>
      find(store.unknownWords.unknownWords?.data?.result, ({ id }) =>
        areSameValue(id, unknownWordId),
      ),
    ) || {}

  const onSuccess = useCallback(() => {
    firebase.logEvent(
      ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_UNKNOWN_WORDS
        .MENU_CURATOR_END_UPDATE_UNKNOWN_WORDS,
      {
        menuCurationTaskId,
        sessionId: sessionId.current,
        eventCategory:
          ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_UNKNOWN_WORDS,
      },
    )

    apolloService.query({
      query: MENU_CURATION_TASK_REFRESH_COUNTS_QUERY,
      variables: { id: menuCurationTaskId },
      dispatch,
      action: REFRESH_MENU_CURATION_TASK_COUNTS,
    })
  }, [dispatch, menuCurationTaskId])

  const mutate = useCallback(
    data => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_UNKNOWN_WORDS
          .MENU_CURATOR_START_UPDATE_UNKNOWN_WORDS,
        {
          menuCurationTaskId,
          sessionId: sessionId.current,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_UNKNOWN_WORDS,
        },
      )

      apolloService.mutate({
        mutation: CONFIRM_UNKNOWN_WORD_MUTATION,
        variables: { id: unknownWordId, data },
        dispatch,
        action: CONFIRM_UNKNOWN_WORD,
        onSuccess,
      })
    },
    [dispatch, menuCurationTaskId, onSuccess, unknownWordId],
  )

  return [mutate, { isLoading, error }]
}

export default useConfirmUnknownWordMutation
